<template>
  <div>
    <div class="q-tit">{{titleData}}</div>
    <div class="content" v-for="(item, index) in dataList" :key="index">
      <div class="page-section">
        <div class="page-section-title">
          {{ index + 1 }}. {{ item.questionDesc }}({{
            item.questionType == 1 ? "单选" : "多选"
          }})
        </div>
        <div v-if="item.questionType == 1">
          <van-radio-group v-model="item.answers">
            <van-radio v-for="(cItem, idx) in item.optionsList"
                       :key="idx" :name="cItem.optionsCode">
              {{ cItem.optionsCode }}、{{ cItem.optionsDesc }}
            </van-radio>
          </van-radio-group>
        </div>

        <div v-if="item.questionType == 2">
          <van-checkbox-group v-model="item.answers">
            <van-checkbox shape="square"
                          v-for="(cItem, idx) in item.optionsList"
                          :key="idx" :name="cItem.optionsCode"
            >{{ cItem.optionsCode }}、{{ cItem.optionsDesc }}
            </van-checkbox>
          </van-checkbox-group>
        </div>
      </div>
    </div>
    <van-button round type="info" @click.prevent="submit">提交</van-button>
  </div>
</template>
<script>
import URL from "@/api/api";
import { Toast } from 'vant';
import { UrlSearch ,getShareInfo} from '@/utils/utils';
export default {
  data() {
    return {
      radio: "",
      active: "",
      openid: '',
      flag: this.$route.query.flag,
      typeId: this.$route.query.typeId,
      titleData: '',
      qaDesc:'',
      result: [],
      dataList: [],
    };
  },
  mounted() {
    this.openid=localStorage.getItem('openid')
    if(!this.openid){
      this.getCustomerCodeUrl()
    }
    this.findQaType();
    this.getQuestions()
  },
  methods: {
    getWxShare(){
      // const url=this.commonUrl.F_URL
      const url=process.env.VUE_APP_BASE_URL
      let data={
        geturl:`/activities/card/signInfo?url=${url}`,
        typeId:this.typeId,
        shareImg:'https://dtfcloud.com/share-pic/questionnaire.jpg',
        titleData:this.titleData,
        qaDesc:this.qaDesc,
        // linkUrl:this.commonUrl.SHARE_QU
        linkUrl:process.env.VUE_APP_BASE_URL+ '#/previewQuestionnaire/details?show=1&typeId='
      }
      getShareInfo(data)
    },
    getCustomerCodeUrl() {
      this.openid = UrlSearch().openid
      if (!this.openid && !this.flag) {
        this.$fetchGet(URL.getCustomerCodeUrl.url, {"typeId": this.typeId}).then(res => {
          if (res.data.code == 20000) {
            window.location.href = res.data.data
          }
        });
      }
    },
    findQaType(){
      this.$fetchGet(URL.findQaType.url, {"id": this.typeId}).then(res => {
        if (res.data.code == 20000) {
           this.titleData = res.data.data.title
           this.qaDesc=res.data.data.qaDesc
           this.getWxShare()
        }
      })
    },
    //查询单个问卷所有问题
    getQuestions() {
      this.$fetchGet(URL.oneQuestionnaire.url, {
        typeId: this.typeId,
        openid: this.openid,
      }).then((res) => {
        this.dataList = res.data.data;
      });
    },
    submit() {
      let checkData=[]
      this.dataList.map(x=>{
        var checkList={}
        checkList.answerOptions=x.answers.toString()
        checkList.questionId=x.id
        checkData.push(checkList)
      })
      let data={
        typeId:this.typeId,
        openId:this.openid,
        answers:checkData
      }

      this.$fetchPost(URL.saveQuestionnaire.url,data).then(res=>{
        Toast(res.data.msg);
      })
    },
  },
};
</script>
<style scoped>
.q-tit {
  font-size: 20px;
  text-align: center;
  padding-top: 10px;
}

.content {
  width: 95%;
  margin: 10px auto;
  padding: 10px;
  background: #fff;
  border-radius: 5px;
  font-size: 0.3rem;
}
.van-radio,
.van-checkbox {
  padding-top: 15px;
}
.van-button--info {
  width: 80%;
  left: 50%;
  transform: translateX(-50%);
}
.van-popup {
  background-color: #f2f3f5;
}
.van-grid {
  width: 95%;
  margin: auto;
}
.checkNav {
  display: flex;
  margin-top: 15px;
  background: #f7f8fa;
}
</style>
